import PillLabel from "./PillLabel";

export default function Phone({ phone }) {
	return <PillLabel>
		<a href={`tel:${phone}`}>
			{phone}
		</a>
	</PillLabel>
}